import { getAllUrlParams, removeUrlQuery } from './main.js'
import { wxLoginUrl, wxAppId } from './url.js'
//微信授权
function wxAuth(callback) {
  let Hurl = window.location.href;
  let url = encodeURIComponent(
    wxLoginUrl + "/ucapi/wechat/v1/loginByMp?mpNumber=1&redirectUrl=" + Hurl
  );

  let code = getAllUrlParams(Hurl).code || "";
  //let uuid = mainjs.getAllUrlParams(Hurl).uuid || "";
  let uuid = getAllUrlParams(Hurl).msg || "";
  let evidence = getAllUrlParams(Hurl).evidence || "";

  var wxUserUuid = window.localStorage.getItem("wxUserUuid") || "";
  if (wxUserUuid != "") {
    //本地已经存有uuid，从这里开始投票
    callback(wxUserUuid);
  } else {
    if (code == 200 && evidence != "") {
      let self = this;
      $.ajax({
        url: wxLoginUrl + "/ucapi/wechat/v1/loginInfoByEvidence",
        data: {
          evidence: evidence
        },
        type: "POST",
        success: function(res) {
          if (res.code == 200) {
            uuid = res.data.uuid;
            window.localStorage.setItem("wxUserUuid", uuid);
            //第一次获取到uuid，从这里开始投票
            callback(uuid);
          } else {
            //凭据失效
            // window.location.href = mainjs.removeUrlQuery(Hurl, [
            // "code",
            // "msg",
            // "uuid",
            // "nickName",
            // "evidence"
            // ]);
            let hasAuth = sessionStorage.getItem("wxHasAuth");
            if (!hasAuth) { //没有授权过
              sessionStorage.setItem('wxHasAuth', true);
              var disUrl = encodeURIComponent(
                wxLoginUrl +
                "/ucapi/wechat/v1/loginByMp?mpNumber=1&redirectUrl=" +
                removeUrlQuery(Hurl, [
                  "code",
                  "msg",
                  "uuid",
                  "nickName",
                  "evidence"
                ])
              );

              jumpWxAuth(disUrl)
            }
          }
        },
        error: function(res) {
          /*self.$store.dispatch("SHOW_TOAST", {
            text: "请刷新试试",
            type: 1
          });*/
        }
      });
      // window.localStorage.setItem("wxUserUuid", decodeURI(uuid));
      // //第一次获取到uuid，从这里开始投票
      // this.wechatVote(decodeURI(uuid));
    } else {
      jumpWxAuth(url)
    }
  }
}

function jumpWxAuth (url) {
  const wxAuthKey = 'wx_auth';
  const urlParams = getAllUrlParams() || {};
  const urlWxAuth = urlParams[wxAuthKey]
  const wxAuth = sessionStorage.getItem(wxAuthKey);
  if (urlWxAuth !== '0' && wxAuth !== '0') {
    window.location.href =
      "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
      wxAppId +
      "&redirect_uri=" +
      url +
      "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
  } else {
    sessionStorage.setItem(wxAuthKey, '0')
  }
}


function getUuid(callback) {
  let Hurl = window.location.href;
  let url = encodeURIComponent(
    wxLoginUrl + "/ucapi/wechat/v1/loginByMp?mpNumber=1&redirectUrl=" + Hurl
  );

  let code = getAllUrlParams(Hurl).code || "";
  //let uuid = mainjs.getAllUrlParams(Hurl).uuid || "";
  let uuid = getAllUrlParams(Hurl).msg || "";
  let evidence = getAllUrlParams(Hurl).evidence || "";

  var wxUserUuid = window.localStorage.getItem("wxUserUuid") || "";
  if (wxUserUuid != "") {
    //本地已经存有uuid，从这里开始投票
    callback(wxUserUuid);
  } else {
    if (code == 200 && evidence != "") {
      let self = this;
      $.ajax({
        url: wxLoginUrl + "/ucapi/wechat/v1/loginInfoByEvidence",
        data: {
          evidence: evidence
        },
        type: "POST",
        success: function(res) {
          if (res.code == 200) {
            uuid = res.data.uuid;
            window.localStorage.setItem("wxUserUuid", uuid);
            //第一次获取到uuid，从这里开始投票
            callback(uuid);
          }
        }
      })
    }
  }
}
export { wxAuth, getUuid };



// WEBPACK FOOTER //
// ./src/js/wx.js